export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
        
        /* eslint-disable */
        console.log('sal,n salon');

        function desktopSlider() {
            setTimeout(function () {
                // eslint-disable-next-line
                var homeSliderOne = $('#salon-location-slider-one').lightSlider({
                        item: 1,
                        autoWidth: false,
                        slideMove: 1, // slidemove will be 1 if loop is true

                        // mode: 'fade',
                        mode: 'slide',
                        useCSS: true,
                        // useCSS: false,

                        speed: 800, //ms'
                        auto: false,
                        loop: false,
                        slideEndAnimation: false,
                        // pause: 2000,

                        keyPress: false,
                        controls: false,
                        prevHtml: '',
                        nextHtml: '',

                        rtl: false,
                        adaptiveHeight: false,

                        pager: false,
                        gallery: false,
                        thumbMargin: 0,
                        slideMargin: 0,
                        currentPagerPosition: 'left',

                        enableTouch: true,
                        enableDrag: false,
                        freeMove: false,
                        swipeThreshold: 1,

                        responsive: [{
                            breakpoint: 768,
                            settings: {
                                slideMargin: 60,
                                enableTouch: true,
                                enableDrag: true,
                            },
                        }],

                        onBeforeStart: function (el) { },
                        onSliderLoad: function (el) { },
                        onBeforeSlide: function (el) {},
                        onAfterSlide: function (el) {},
                        onBeforeNextSlide: function (el) { },
                        onBeforePrevSlide: function (el) { }
                    });
                    
                var homeSliderTwo = $('#salon-location-slider-two').lightSlider({
                        item: 1,
                        autoWidth: false,
                        slideMove: 1, // slidemove will be 1 if loop is true

                        // mode: 'fade',
                        mode: 'slide',
                        useCSS: true,
                        // useCSS: false,

                        speed: 800, //ms'
                        auto: false,
                        loop: false,
                        slideEndAnimation: false,

                        keyPress: false,
                        controls: false,
                        prevHtml: '',
                        nextHtml: '',

                        rtl: false,
                        adaptiveHeight: false,

                        pager: false,
                        gallery: false,
                        thumbMargin: 0,
                        slideMargin: 0,
                        currentPagerPosition: 'left',

                        enableTouch: true,
                        enableDrag: false,
                        freeMove: false,
                        swipeThreshold: 1,

                        responsive: [{
                            breakpoint: 768,
                            settings: {
                                slideMargin: 60,
                                enableTouch: true,
                                enableDrag: true,
                            },
                        }],

                        onBeforeStart: function (el) { },
                        onSliderLoad: function (el) { },
                        onBeforeSlide: function (el) {
                            $('#salon-location-sliders #salon-location-slider-one li .image-wrapper').addClass('active');
                            // $('#home-section-three li img').addClass('transition');
                        },
                        onAfterSlide: function (el) {
                            $('#salon-location-slider-one li .image-wrapper').removeClass('active');
                            $('#salon-location-slider-one li img').removeClass('transition');

                            let prevArrow = document.querySelector('#salon-location-sliders .desktop .bws-arrow.prev');
                            let nextArrow = document.querySelector('#salon-location-sliders .desktop .bws-arrow.next');
                            let currentSlide = $('#salon-location-sliders #salon-location-slider-one .bws-slide.active').data('count');

                            if (currentSlide == 1) {
                                prevArrow.classList.add('disabled');
                                nextArrow.classList.remove('disabled');
                            } else if (currentSlide == pagerItems) {
                                prevArrow.classList.remove('disabled');
                                nextArrow.classList.add('disabled');
                            } else {
                                prevArrow.classList.remove('disabled');
                                nextArrow.classList.remove('disabled');
                            }
                        },
                        onBeforeNextSlide: function (el) { },
                        onBeforePrevSlide: function (el) { }
                    });

                let pagerItems = $('#salon-location-sliders #salon-location-slider-one li.bws-slide').length;
                let currentSlide = $('#salon-location-sliders #salon-location-slider-one .bws-slide.active').data('count', 1);

                $('.bws-pager.desktop .bws-arrow').click(function (e) {
                    e.preventDefault();

                    // Arrows move the slider next or prev
                    if ($(this).hasClass('next')) {
                        homeSliderOne.goToNextSlide();
                        homeSliderTwo.goToNextSlide();
                    } else if ($(this).hasClass('prev')) {
                        homeSliderOne.goToPrevSlide();
                        homeSliderTwo.goToPrevSlide();
                    }
                });
            
            // }, 500);
            }, 200);
        }

        function mobileSlider() {
            setTimeout(function () {
                var mobileSlider = $('#salon-location-slider-mobile').lightSlider({
                    item: 1,
                    autoWidth: false,
                    slideMove: 1, // slidemove will be 1 if loop is true

                    // mode: 'fade',
                    mode: 'slide',
                    useCSS: true,
                    // useCSS: false,

                    speed: 800, //ms'
                    auto: false,
                    loop: false,
                    slideEndAnimation: false,

                    keyPress: false,
                    controls: false,
                    prevHtml: '',
                    nextHtml: '',

                    rtl: false,
                    adaptiveHeight: false,

                    pager: false,
                    gallery: false,
                    thumbMargin: 0,
                    slideMargin: 0,
                    currentPagerPosition: 'left',

                    enableTouch: true,
                    enableDrag: false,
                    freeMove: false,
                    swipeThreshold: 1,

                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slideMargin: 0,
                            enableTouch: true,
                            enableDrag: true,
                        },
                    }],

                    onBeforeStart: function (el) { },
                    onSliderLoad: function (el) { },
                    onBeforeSlide: function (el) {
                        // $('#salon-location-sliders #salon-location-slider-mobile li .image-wrapper').addClass('active');
                        $('#salon-location-sliders #salon-location-slider-mobile li .image-wrapper').addClass('active');
                        // $('#home-section-three li img').addClass('transition');
                    },
                    onAfterSlide: function (el) {
                        $('#salon-location-slider-mobile li .image-wrapper').removeClass('active');
                        $('#salon-location-slider-mobile li img').removeClass('transition');

                        let prevArrow = document.querySelector('#salon-location-sliders .mobile .bws-arrow.prev');
                        let nextArrow = document.querySelector('#salon-location-sliders .mobile .bws-arrow.next');
                        let currentSlide = $('#salon-location-sliders #salon-location-slider-mobile .bws-slide.active').data('count');
                        // let pagerItems = $('#salon-location-sliders #salon-location-slider-mobile li.bws-slide').length - 1;

                        console.log('currentSlide', currentSlide, pagerItems, el.getCurrentSlideCount(), el);

                        if (currentSlide == 1) {
                            prevArrow.classList.add('disabled');
                            nextArrow.classList.remove('disabled');
                        } else if (currentSlide == pagerItems) {
                            prevArrow.classList.remove('disabled');
                            nextArrow.classList.add('disabled');
                        } else {
                            prevArrow.classList.remove('disabled');
                            nextArrow.classList.remove('disabled');
                        }
                    },
                    onBeforeNextSlide: function (el) { },
                    onBeforePrevSlide: function (el) { }
                });

                let pagerItems = $('#salon-location-sliders #salon-location-slider-mobile li.bws-slide').length;
                let currentSlide = $('#salon-location-sliders #salon-location-slider-mobile .bws-slide.active').data('count', 1);

                $('.bws-pager.mobile .bws-arrow').click(function (e) {
                    e.preventDefault();

                    // Arrows move the slider next or prev
                    if ($(this).hasClass('next')) {
                        mobileSlider.goToNextSlide();
                    } else if ($(this).hasClass('prev')) {
                        mobileSlider.goToPrevSlide();
                    }
                });
            }, 200);
        }

        function teamSlider() {
            setTimeout(function () {
                var mobileSlider = $('#salon-location-slider-team').lightSlider({
                    item: 1,
                    autoWidth: false,
                    slideMove: 1, // slidemove will be 1 if loop is true

                    // mode: 'fade',
                    mode: 'slide',
                    useCSS: true,
                    // useCSS: false,

                    speed: 800, //ms'
                    auto: false,
                    loop: false,
                    slideEndAnimation: false,

                    keyPress: false,
                    controls: false,
                    prevHtml: '',
                    nextHtml: '',

                    rtl: false,
                    adaptiveHeight: false,

                    pager: false,
                    gallery: false,
                    thumbMargin: 0,
                    slideMargin: 0,
                    currentPagerPosition: 'left',

                    enableTouch: true,
                    enableDrag: true,
                    freeMove: false,
                    swipeThreshold: 1,

                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            move: 1,
                            slideMargin: 0,
                            enableTouch: true,
                            enableDrag: true,
                        },
                    }],

                    onBeforeStart: function (el) { },
                    onSliderLoad: function (el) { },
                    onBeforeSlide: function (el) {
                        $('#salon-location-slider-team li .image-wrapper').addClass('active');
                        // $('#home-section-three li img').addClass('transition');
                    },
                    onAfterSlide: function (el) {
                        $('#salon-location-slider-team li .image-wrapper').removeClass('active');
                        $('#salon-location-slider-team li img').removeClass('transition');

                        let prevArrow = document.querySelectorAll('#sl-team .bws-arrow.prev');
                        let nextArrow = document.querySelectorAll('#sl-team .bws-arrow.next');
                        let currentSlide = $('#salon-location-slider-team .bws-slide.active').data('count');

                        if (currentSlide == 1) {
                            prevArrow.forEach(a => { a.classList.add('disabled') });
                            nextArrow.forEach(a => { a.classList.remove('disabled') });
                        } else if (currentSlide == pagerItems) {
                            prevArrow.forEach(a => { a.classList.remove('disabled') });
                            nextArrow.forEach(a => { a.classList.add('disabled') });
                        } else {
                            prevArrow.forEach(a => { a.classList.remove('disabled') });
                            nextArrow.forEach(a => { a.classList.remove('disabled') });
                        }
                    },
                    onBeforeNextSlide: function (el) { },
                    onBeforePrevSlide: function (el) { }
                });

                let pagerItems = $('#salon-location-slider-team li.bws-slide').length;
                let currentSlide = $('#salon-location-slider-team .bws-slide.active').data('count', 1);

                $('#sl-team .bws-pager .bws-arrow').click(function (e) {
                    e.preventDefault();

                    // Arrows move the slider next or prev
                    if ($(this).hasClass('next')) {
                        mobileSlider.goToNextSlide();
                    } else if ($(this).hasClass('prev')) {
                        mobileSlider.goToPrevSlide();
                    }
                });
            }, 200);
        }


        desktopSlider()
        mobileSlider()
        teamSlider()

    },
}




// WEBPACK FOOTER //
// ./scripts/routes/templateSalonLocation.js